import {action, makeObservable, observable} from "mobx";

import {BaseWidgetDisplayModel} from "../../models/base-widget-display-model";
import {BettingPromotionRemoteConfigModel} from "../../models/betting-promotion/betting-promotion.remote-config.model";
import {BaseTerms} from "../../../infrastructure/models/base-terms";
import {BettingPromotionLocalStorageModel} from "../../models/betting-promotion/betting-promotion.local-storage.model";

export class AppBettingPromotionDisplayModel extends BaseWidgetDisplayModel {
  @observable isVisible: Boolean;
  @observable isCampaignLink: Boolean;
  @observable isValidVisibility: Boolean;
  @observable remoteConfigModel: BettingPromotionRemoteConfigModel;
  @observable localStorageModel: BettingPromotionLocalStorageModel;
  @observable topBookmakerId: Number;
  @observable terms: Number;

  constructor(model: Object, terms: BaseTerms, topBookmakerId: Number) {
    super();

    this.remoteConfigModel = model && new BettingPromotionRemoteConfigModel(model, terms, topBookmakerId);
    this.isVisible = false;
    this.isValidVisibility = false;
    this.topBookmakerId = topBookmakerId;
    this.terms = terms;

    makeObservable(this);
  }

  @action updateRemoteConfigModel(model) {
    this.remoteConfigModel = model
  }
}
